import { AdminDataInt, AdminResponseInt } from '@app/interfaces/admin.interface';
import { Admin } from '@app/enums';
export class AdminMapper {
  optionsAdmin: string[] = ['LOCALES', 'portPinpad'];

  constructor() {
    // noop
  }

  mapDTOModel(data: AdminResponseInt): AdminDataInt {
    let admin: AdminDataInt = {
      bagTag: true,
      DOCV: true,
      HANDLE_OVERWEIGHT_BAG: false,
      noPassportScanner: false,
      outOfService: false,
      Payment: true,
      scale: true,
      SHOW_OVERBOOKING_VOLUNTEER_OFFER: false,
      SHOW_PREMIERE_OFFER: false,
      SHOW_SEAT_SELECT_PREMIERE_OFFER: false,
      TSA: false,
      WAIT_FOR_AGENT: false,
      AM_PLUS_UPSELL: false,
      Payment_And_Weighing_Test: false,
      INTERNATIONALROUTES: true,
      USA_REQUIREMENTS: false,
      showIrops: false,
      showUSPerson: true,
      showSeatMap: true,
      upgradeSeats: false,
      iropReaccommed: false,
      showAruExperience: false,
      baggageOnlyFlow: false,
      allowWCHRBoardingPass: false,
      SHOW_CHUBB_INSURANCE: false,
      allowBaggageInsurance: false,
      allowSessionRecording: false,
      // CI-22888: fail-safe deshabilitado por defecto; el backend (kiosk-profile) envia el valor real.
      SHOW_FEM: false,
    };
    admin.maletas25KG = data.maletas25KG;

    for (const adminElement of data?.collection) {
      if (!this.optionsAdmin.includes(adminElement.name)) {
        if (Object.keys(admin).includes(adminElement.name)) {
          if (adminElement.value === '0' || adminElement.value === '') {
            adminElement.value = 'false';
          }
          admin[adminElement.name] = this.determinateValue(adminElement.value);
        } else if (adminElement.name === Admin.DEFAULT_LANGUAGE) {
          adminElement.value ??= 'es-MX';
          admin[adminElement.name] = adminElement.value;
        } else if (typeof this.determinateValue(adminElement.value) !== 'boolean') {
          admin[adminElement.name] = this.determinateValue(adminElement.value);
        }
      } else {
        admin[adminElement.name] = adminElement.value.split('~');
      }
    }

    if (!admin.hasOwnProperty(Admin.DEFAULT_LANGUAGE)) {
      admin[Admin.DEFAULT_LANGUAGE] = 'es-MX';
    }
    const parsedDecimals = parseInt(admin.numberOfDecimalsBE as unknown as string, 10);
    admin.numberOfDecimalsBE = Number.isInteger(parsedDecimals) ? parsedDecimals : 2;
    return admin;
  }

  determinateValue(value: string): any {
    let data: any = value;
    const compareData = value?.toLowerCase();
    if (['true', 'false'].includes(compareData)) {
      data = compareData === 'true';
    }
    return data;
  }
}
